import { type HTMLAttributes } from "react";

import { Button } from "../button/Button";

import type { DateValue } from "react-aria-components";

interface RangePresetButtonProps extends HTMLAttributes<HTMLButtonElement> {
  value: { start: DateValue; end: DateValue };
}

export const RangePresetButton = ({ children, ...props }: RangePresetButtonProps) => {
  return (
    <Button ghost variant="light" onClick={props.onClick}>
      {children}
    </Button>
  );
};
